import {
  InsightResolutionFragment,
  InsightSubResolutionFragment,
} from 'core/graphql';

export type InsightResolutionRow =
  | Omit<InsightResolutionFragment, '__typename'>
  | Omit<InsightSubResolutionFragment, '__typename'>;

export const isParentResolution = (
  row: InsightResolutionRow
): row is InsightResolutionFragment => row.hasOwnProperty('subResolutions');

export const isSubResolution = (
  row: InsightResolutionRow
): row is InsightSubResolutionFragment => !row.hasOwnProperty('subResolutions');
